var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","loading":_vm.loading,"disabled":_vm.loading || _vm.disabled},on:{"click":_vm.submit}},[_vm._v("\n  "+_vm._s(_vm.needVerify ? '提交审核并进入下一个项目' : '进入下一个项目')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }